import { UseMutationResult, useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

import axiosInstance from "../../shared/service/axios";
import { ConsoleListResponse } from "./Console.constants";

export const useConsoleListMutation = (): UseMutationResult<
  ConsoleListResponse,
  AxiosError,
  any
> =>
  useMutation<ConsoleListResponse, AxiosError, any>(async (requestValues) => {
    if (requestValues === 0) {
      const { data, status } = await axiosInstance.get("log/");

      return data;
    } else {
      const { data, status } = await axiosInstance.get("log/", {
        params: {
          content_type: requestValues,
        },
      });

      return data;
    }
  });
